/* Animal faces, so a child who cannot read finds themselves by picture.
 * Deliberately emoji rather than an icon set: they render at any size, need no
 * asset pipeline, and a five-year-old already knows what a fox is. */
const FACES: Record<string, string> = {
  fox: "🦊", panda: "🐼", bear: "🐻", cat: "🐱", dog: "🐶", frog: "🐸",
  owl: "🦉", bee: "🐝", turtle: "🐢", penguin: "🐧", lion: "🦁", koala: "🐨",
  parent: "🌟",
};

export const AVATAR_KEYS = Object.keys(FACES).filter((k) => k !== "parent");

export function Avatar({
  name,
  size = 64,
  ring,
}: {
  name: string;
  size?: number;
  ring?: string | null;
}) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        display: "inline-grid",
        placeItems: "center",
        borderRadius: "50%",
        background: "var(--paper)",
        border: `3px solid ${ring || "var(--paper-edge)"}`,
        fontSize: size * 0.55,
        lineHeight: 1,
        flex: "0 0 auto",
      }}
    >
      {FACES[name] ?? FACES.fox}
    </span>
  );
}
